export enum ColorEnum {
  BASE = "base",
  AMBER = "amber",
  BLUE = "blue",
  DARKBLUE = "darkblue",
  DARKERBLUE = "darkerblue",
  GREEN = "green",
  DARKGREEN = "darkgreen",
  RED = "red",
  SLATE = "slate",
  WHITE = "white",
  YELLOW = "yellow",

  BLUEORIGINAL = "blue-original",
  GREENORIGINAL = "green-original",
  STEELBLUE = "steelblue",
  DEEPCYAN = "deepcyan",
  GRAY = "gray",
  TEAL = "teal",
  NAVY = "navy",
  JADE = "jade",
  LIGHT_GRAY = "lightgray",
  OLIVE_GRAY = "olivegray",
  DARKJADE = "darkjade",
  GOLDEN = "golden",
}

export enum ScreenWidthEnum {
  BASE = 0,
  MOBILE = 481,
  SMALL_TABLET = 641,
  IPAD_PORTRAIT = 769,
  TABLET = 801,
  IPAD_LANDSCAPE = 1025,
  DESKTOP = 1201,
}

export enum ButtonActionEnum {
  BUTTON = "button",
  RESET = "reset",
  SUBMIT = "submit",
}

export enum IconEnum {
  ATOL = "atol",
  BED = "bed",
  BED_DOUBLE = "bed-double",
  BED_SINGLE = "bed-single",
  BED_TWIN = "bed-twin",
  CALENDAR = "calendar",
  CHECK = "check",
  CIRCLE_EXCLAMATION = "circle-exclamation",
  CIRCLE_STAR = "circle-star",
  EXCLAMATION = "exclamation",
  GOLF_BALL_TEE = "golf-ball-tee",
  HOTEL = "hotel",
  MOON = "moon",
  PLANE = "plane",
  PLANE_DEPARTURE = "plane-departure",
  USER = "user",
  HOTEL_OUTLINE = "hotel-outline",
  GOLF_FLAG_HOLE_OUTLINE = "golf-flag-hole-outline",
  GOLF_BALL_TEE_OUTLINE = "golf-ball-tee-outline",
  LOCATION_PIN = "location-pin",
  FLAG = "flag",
  FLOWER = "flower",
  STAR = "star",
  MAP = "map",
}

export enum SizeEnum {
  X_SMALL = "x-small",
  SMALL = "small",
  STANDARD = "standard",
  LARGE = "large",
  X_LARGE = "x-large",
  XX_LARGE = "xx-large",
  X3_LARGE = "x3-large",
}

export enum TextInputEventEnum {
  BLUR = "blur",
  CHANGE = "change",
  FOCUS = "focus",
  INPUT = "input",
}

export enum ImageFetchPriorityEnum {
  AUTO = "auto",
  HIGH = "high",
  LOW = "low",
}

export enum ImageLoadingEnum {
  EAGER = "eager",
  LAZY = "lazy",
}

export enum ImageProviderEnum {
  BUCKET = "bucket",
  CLOUDINARY = "cloudinary",
  CONTENTFUL = "contentful",
  EXTERNAL = "external",
}

export enum ImageVariantEnum {
  BANNER = "banner",
  CARD = "card",
  CARD2X = "card2x",
  FULLWIDTH = "fullwidth",
  GRID = "grid",
  HERO = "hero",
  LIGHTBOX = "lightbox",
  NONE = "none",
  PRIMARY = "primary",
  RADIO = "radio",
  SECONDARY = "secondary",
  SEARCH = "search",
  SUMMARY = "summary",
  THUMBNAIL = "thumbnail",
}

export enum LegendPositionEnum {
  CENTER = "center",
  RIGHT = "right",
}

export enum LabelPositionEnum {
  Left = "left",
  Right = "right",
}

export enum TooltipPlacement {
  BOTTOM = "bottom",
  BOTTOM_RIGHT = "bottom-right",
  TOP = "top",
}

export enum RoundedEnum {
  LG = "lg",
}
